<template>
  <nav class="shadow-card mx-auto w-fit rounded bg-white p-2.5">
    <ul class="flex items-center justify-center gap-1">
      <li>
        <button
          class="flex h-10 w-10 items-center justify-center rounded-md text-zinc-600 transition-colors hover:bg-zinc-100"
          :class="{
            'pointer-events-none opacity-50': page === 1
          }"
          :disabled="page === 1"
          @click="handlePageButtonClick(page - 1)"
        >
          <Icon class="text-2xl" name="keyboard_arrow_left" />
        </button>
      </li>

      <li v-if="showFirstPage">
        <button
          class="flex h-10 w-10 items-center justify-center rounded-md text-zinc-600 transition-colors hover:bg-zinc-100"
          @click="handlePageButtonClick(1)"
        >
          1
        </button>
      </li>

      <li v-if="showLeftEllipsis">
        <span class="p-2 text-zinc-600">...</span>
      </li>

      <li v-for="visiblePage in visiblePages" :key="visiblePage">
        <button
          :class="`${visiblePage === page ? 'bg-primary text-white' : 'text-zinc-600 hover:bg-zinc-100'} flex h-10 w-10 items-center justify-center rounded-md`"
          @click="handlePageButtonClick(visiblePage)"
        >
          {{ visiblePage }}
        </button>
      </li>

      <li v-if="showRightEllipsis">
        <span class="p-2 text-zinc-600">...</span>
      </li>

      <li v-if="showLastPage">
        <button
          class="flex h-10 w-10 items-center justify-center rounded-md text-zinc-600 transition-colors hover:bg-zinc-100"
          @click="handlePageButtonClick(pages)"
        >
          {{ pages }}
        </button>
      </li>

      <li>
        <button
          class="flex h-10 w-10 items-center justify-center rounded-md text-zinc-600 transition-colors hover:bg-zinc-100"
          :class="{
            'pointer-events-none opacity-50': page === pages
          }"
          :disabled="page === pages"
          @click="handlePageButtonClick(page + 1)"
        >
          <Icon class="text-2xl" name="keyboard_arrow_right" />
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup>
  import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
  import { Icon } from '@/components/block/icon';

  const props = defineProps({
    pages: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    }
  });

  const emit = defineEmits(['update:page']);

  const visiblePages = computed(() => {
    if (isMobile.value) {
      return [props.page];
    }

    const startPage = Math.max(1, props.page - 1);
    const endPage = Math.min(props.pages, props.page + 1);

    const pageList = [];

    for (let i = startPage; i <= endPage; i++) {
      pageList.push(i);
    }

    return pageList;
  });

  const showFirstPage = computed(() => visiblePages.value[0] !== 1);
  const showLastPage = computed(
    () => visiblePages.value[visiblePages.value.length - 1] !== props.pages
  );
  const showLeftEllipsis = computed(() => visiblePages.value[0] > 2);
  const showRightEllipsis = computed(
    () => visiblePages.value[visiblePages.value.length - 1] < props.pages - 1
  );

  const isMobile = ref(window.innerWidth < 768);

  function handleResize() {
    isMobile.value = window.innerWidth < 768;
  }

  function handlePageButtonClick(index) {
    emit('update:page', index);
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
  });
</script>
